import React from 'react';
import { Box } from '@chakra-ui/react';
import {
  CampaignMappingView,
  CampaignMappingsDataContextProvider,
} from 'src/features/CampaignMapping';

export const CampaignsTab: React.FC = () => {
  return (
    <CampaignMappingsDataContextProvider>
      <Box>
        <CampaignMappingView />
      </Box>
    </CampaignMappingsDataContextProvider>
  );
};
